'use strict';

module.exports = {
  template: require('./change-manager.html'),
  controller: require('./change-manager.controller'),
  controllerAs: 'vm',

  bindings: {
    me: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/change-manager/index.js
 ** module id = 159
 ** module chunks = 0
 **/